import React from 'react'
import { sharedData } from '../../../models/shared_data'
import { Subject } from 'rxjs'

import { superagent } from '../../shared/superagent/superagent';
import singletons from '../../shared/singletons'
import { Observable } from 'rxjs'
import { Scrollbars } from 'react-custom-scrollbars';

class AutocompleteApi {
  suggest(val, name, constraints) {
    return Observable.create((obs)=> {
      singletons['loading'].start()
      superagent.post("/api/address")
        .send({q: val, t: name, constraints: constraints})
        .end((err, resp)=> {
          const data = resp.body
          singletons['loading'].stop()
          obs.next(data)
          obs.complete()
        })
    })
  }
}

export class AddressAutocomplete extends React.Component {
  constructor(props) {
    super(props)
    this.api = new AutocompleteApi()

    this.state = {
      isOpened: false,
      internalVal: props.val,
      width: 100,
      suggestions: []
    }
    this.s = new Subject()
    this.s.debounceTime(1000)
      .subscribe(()=> {
        this.updateSuggestions()
      })

    this.toggle = this.toggle.bind(this)
    this.selectSuggestion = this.selectSuggestion.bind(this)
    this.updateSuggestions = this.updateSuggestions.bind(this)
    this.setComponentRef = this.setComponentRef.bind(this)
    this.actualChangeField = this.actualChangeField.bind(this)
  }


  setComponentRef(ref) {
    if(!ref)
      return
    this.componentRef = ref
    this.setState({
      width: ref.offsetWidth
    })
  }

  toggle() {
    this.setState({
      isOpened: !this.state.isOpened
    })
  }

  componentWillUnmount() {
    this.s.complete()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.val != this.props.val) {
      this.setState({
        internalVal: this.props.val
      })
    }
  }

  updateSuggestions() {
    this.api.suggest(this.state.internalVal, this.props.modelName, this.props.constraints)
      .subscribe((r)=> {
        this.setState({
          isOpened: true,
          suggestions: r['suggests']
        })
      })
  }

  updated(e) {
    e.preventDefault()
    this.setState({
      internalVal: e.target.value
    })
    if(sharedData.isAddressAutocomplete) {
      this.s.next(true)
    }
    this.actualChangeField(e.target.value)
  }

  actualChangeField(v) {
    if(this.props.onChange) {
      let new_constr = {}
      const c = this.props.constraints
      Object.keys(c).forEach((k)=> {
        new_constr[k] = c[k]
      })

      new_constr[this.props.modelName] = v
      this.props.onChange({address: new_constr})
    }
  }

  selectSuggestion(s) {
    if(this.props.onChange) {
      this.props.onChange({
        address: s.full
      })
    }

    this.setState({
      isOpened: false,
      internalVal: s.value
    })
  }

  isError() {
    if(this.props.error)
      return ' error '
    return ''
  }


  selectAddress(addr) {
    this.props.onChange(addr)
  }

  render() {
    const s = this.state
    return (
      <div className="select-component">
        <div className="input-white">
          <input
            ref={this.setComponentRef}
            className={ "input-white__text" + this.isError() }
            placeholder={ this.props.title }
            type="text"
            value={this.state.internalVal}
            onChange={(e)=>this.updated(e)}
          />

          { s.isOpened &&
            <div>
              <div className="select-component__bg" onClick={this.toggle}></div>
              <div className="select-component__options">
                <Scrollbars
                  autoHeight
                  autoHeightMin={100}
                  autoHeightMax={200}
                  style={{width: this.state.width}}
                >
                  <ul>
                    { s.suggestions.map((it, ind)=>(

                      <li
                        key={ind}
                        className={it.value == '0' ? 'selected' : ''}
                        onClick={()=> { this.selectSuggestion(it) }}
                      >
                        { it.value }
                      </li>
                    ))}
                  </ul>
                </Scrollbars>
              </div>

            </div>
          }

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/address_autocomplete.component.jsx